import qs from 'qs';
import client, { url } from './client';

// 관리자 › 제타트랙 설정 › 클럽 — 모니터링 탭이 쓰는 기존 API 모음 (서버 변경 없음).
//   러닝앱·트랩앱·관리자 출석/기록 화면이 이미 쓰는 라우트를 그대로 부른다.

const rt = (path) => `${url}/api/runningtrack/${path}`;

// 랭킹 — 러닝앱 랭킹 화면과 같은 API. 지금 기간(오늘·이번 주·이번 달)만, 상위 50명 + total.
export const loadTodayRank = (clubID) => client.get(rt(`todayrank/${clubID}`));
export const loadWeeklyRank = (clubID) => client.get(rt(`weeklyrank/${clubID}`));
export const loadMonthlyRank = (clubID) => client.get(rt(`monthlyrank/${clubID}`));

// 회원 — member 행(이름·아이디·닉네임·전화) + 레벨·보유 포인트·신규 러너
export const loadMemberInfo = (memberID, clubID) =>
  client.get(rt(`memberinfo/${memberID}?${qs.stringify({ clubID })}`));
// 최근 30개 날짜 기록 + 최고 랩
export const loadRunRecord = (memberID) => client.get(rt(`record/${memberID}`));
export const loadPointHistory = (memberID, clubID, before, limit) =>
  client.get(rt(`pointhistory/${memberID}?${qs.stringify({ clubID, before, limit })}`));
export const loadPlanProgress = (memberID) => client.get(rt(`plan/progress/${memberID}`));

// 이름·아이디·전화 뒤 4자리로 클럽 회원 찾기. 서버가 검색어를 SQL 에 그대로 넣으므로 따옴표·와일드카드는 뺀다.
export const searchClubMember = (clubID, keyword) => {
  const safe = String(keyword || '').replace(/['"\\%_;`]/g, '').trim();
  return client.get(rt(`number/${encodeURIComponent(safe)}?${qs.stringify({ clubID })}`));
};

export const loadMultiRunRecord = (clubID, startTime, endTime) =>
  client.get(rt(`multirun/record/${clubID}?${qs.stringify({ startTime, endTime })}`));
export const loadClubLoginLog = (clubID, startTime, endTime) =>
  client.get(rt(`clubloginlog/${clubID}?${qs.stringify({ startTime, endTime })}`));
export const loadFaceFailLog = (clubID, startTime, endTime, socketKey) =>
  client.get(rt(`facefaillog/${clubID}?${qs.stringify({ startTime, endTime, socketKey })}`));

// 출입문 기록 — 관리자 출석 화면과 같은 API. 응답은 배열 그대로다.
export const loadClubAttend = (clubID, startTime, endTime, socketKey) =>
  client.get(`${url}/api/attend/${clubID}?${qs.stringify({ startTime, endTime, socketKey })}`);
export const loadMemberAttend = (clubID, playerID, socketKey) =>
  client.get(`${url}/api/attend/${clubID}/${playerID}?${qs.stringify({ socketKey })}`);

// 기록 & 처방 — 날짜별 운동 기록(fcGroup). 제타트랙 러닝은 그날 런닝 항목(fcindex 1)에 더해진다.
export const loadRecordDates = (targetID, socketKey) =>
  client.get(`${url}/api/record/dates?${qs.stringify({ targetID, socketKey })}`);
export const loadRecordOfDate = (targetID, date, socketKey) =>
  client.get(`${url}/api/record?${qs.stringify({ targetID, date, socketKey })}`);
